export class EventData {
    constructor() {
    }
}
